import Owner from '~models/owner'
import Mixpanel from '~utils/mixpanel'

namespace Auth {
  export interface ILogInGuest {
    anonymous_code: string | null
    from_web?: boolean
    firebase_token?: string | null
  }

  export class LogInGuest implements ILogInGuest {
    anonymous_code: string | null = null
    from_web?: boolean
    firebase_token?: string | null

    constructor(json: LogInGuest) {
      this.anonymous_code = json.anonymous_code
      this.from_web = json.from_web ?? true
      if (json.firebase_token) {
        this.firebase_token = json.firebase_token
      }

      return { ...this }
    }
  }
  export namespace LogInGuest {
    export interface Response {
      anonymous_account_id: number
      access_token: string
    }
  }

  export enum LoginType {
    Email = 'email',
    Phone = 'phone',
  }

  export class LogIn {
    type: LoginType = LoginType.Email
    code = ''
    token = ''
    device_os: DeviceOS | null = null
    anonymous_code?: string | null = null
    partner_clinic_id?: number
    is_web?: boolean = true

    constructor(req: LogIn) {
      this.type = req.type
      this.code = req.code
      this.token = req.token
      this.device_os = req.device_os
      this.anonymous_code = req.anonymous_code
      this.partner_clinic_id = req.partner_clinic_id
      this.is_web = req.is_web ?? true
    }
  }

  export interface ISocialLogin {
    platform: 'apple' | 'google' | 'samsung'
    access_token: string
    anonymous_code?: string | null
    is_web?: boolean
  }

  export class SocialLogin implements ISocialLogin {
    platform: 'apple' | 'google' | 'samsung'
    access_token: string
    anonymous_code?: string | null = null
    is_web?: boolean = true

    constructor(req: ISocialLogin) {
      this.access_token = req.access_token
      this.anonymous_code = req.anonymous_code
      this.is_web = req.is_web ?? true
      this.platform = req.platform

      Mixpanel.getDistinctId().then(id => {
        this.anonymous_code = id
      })
    }

    toDto() {
      return { ...this, platform: undefined }
    }
  }

  export namespace LogIn {
    export interface Response {
      owner: Owner.Level1
      access_token: string
      email: string
      phone: string
      reactivation: boolean
      is_first_login: boolean
    }
  }

  export const DeviceOS = {
    IOS: 0,
    ANDROID: 1,
  } as const
  export type DeviceOS = (typeof DeviceOS)[keyof typeof DeviceOS]

  export interface SendOtpToPhoneNumber {
    phone: string
  }
}

export default Auth
